import React, { FC, memo, useCallback, useContext } from 'react'

import { SliderContainer, StyledCarouselProvider, StyledSlider } from './styles'
import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { Slide } from 'pure-react-carousel'
import { ScreenContext } from 'react-components'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import ReviewsCard from '../../common/reviews-card'
import PrevNextControls from '../../common/prev-next-controls'
import { CtaButtonText, CtaContainer, Section, StyledGhostButton, Title, TitleContainer } from '../common/styles'

interface Props {
    topRatedObjectsSection: ListingSectionTransport
    breadcrumbList?: BreadcrumbListTransport
    url: string
    defaultHeading: string
}

const _getSlides = (isMobile: boolean, isTablet: boolean) => {
    if (isMobile) {
        return 1
    } else if (isTablet) {
        return 2
    } else {
        return 3
    }
}

const ReviewsSection: FC<Props> = ({ topRatedObjectsSection, breadcrumbList, url, defaultHeading }) => {
    const { objects: reviewObjects, cta } = topRatedObjectsSection
    const { t } = useTranslation()
    const { isMobile, isTablet, isDesktop } = useContext(ScreenContext)
    const slides = _getSlides(isMobile, isTablet)

    const heading = topRatedObjectsSection.heading || defaultHeading

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = cta?.url || url
    }, [url, cta?.url])

    return (
        <Section id="reviews">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={reviewObjects.length}
                    visibleSlides={isDesktop ? 3 : isTablet ? 1.75 : 1.1}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={1}
                    step={1}
                    center
                >
                    <PrevNextControls totalObjects={reviewObjects.length} visibleSlides={slides} />
                    <StyledSlider $transitionTime={0.2}>
                        {reviewObjects.map((reviewObject, index) => (
                            <Slide index={reviewObject.id} key={reviewObject.id}>
                                <ReviewsCard
                                    key={reviewObject.id}
                                    listing={reviewObject}
                                    position={index}
                                    breadcrumbList={breadcrumbList}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>
            {cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleViewAllAccommodationsClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(ReviewsSection)
